export enum FinaleStockField {
  Stockonhand = "stockOnHand",
  Stockavailable = "stockAvailable",
  Stockreserved = "stockReserved",
  Stockonorder = "stockOnOrder",
}
